<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

// Variant Specs Update Functionality
(function() {
  'use strict';

  // Initialize when DOM is ready
  function initVariantSpecs() {
    // Check if we're on a product page with specs
    const specsContainer = document.querySelector('[data-variant-specs]');
    if (!specsContainer) return;

    // Find the main product form to scope our variant selection
    const productForm = document.querySelector('form[action*="/cart/add"], [data-product-form]');
    if (!productForm) {
      console.log('No product form found, using document scope');
    }

    // Get the current product ID to filter variants
    const productIdInput = productForm ? 
      productForm.querySelector('input[name="product-id"], input[name="id"][type="hidden"]') : 
      document.querySelector('input[name="product-id"], input[name="id"][type="hidden"]');
    
    const currentProductId = productIdInput ? productIdInput.value : null;

    // Listen for variant changes within the product form scope
    const scopeElement = productForm || document;
    scopeElement.addEventListener('change', function(e) {
      // Only respond to variant selectors within this product
      if (e.target.matches('input[name="id"], select[name="id"]') && 
          (!productForm || productForm.contains(e.target))) {
        updateVariantSpecs(e.target.value);
      }
    });

    // Also listen for custom variant change events
    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        updateVariantSpecs(e.detail.variant.id);
      }
    });
  }

  function updateVariantSpecs(variantId) {   
    // Only look for variant data within the specs container to avoid cross-product contamination
    const specsContainer = document.querySelector('[data-variant-specs]');
    const variantData = specsContainer.querySelector(`[data-variant-id="${variantId}"]`);
    
    if (!variantData) {
      // Hide both UPC and SKU fields if no data found
      hideSpecField('[data-spec-upc]');
      hideSpecField('[data-spec-sku]');
      return;
    }

    // Update UPC
    updateSpecField('upc', variantData.dataset.barcode, '[data-spec-upc]');
    
    // Update SKU
    updateSpecField('sku', variantData.dataset.sku, '[data-spec-sku]');
  }

  function updateSpecField(fieldType, newValue, rowSelector) {
    // Only look within the specs container
    const specsContainer = document.querySelector('[data-variant-specs]');
    const valueElement = specsContainer.querySelector(`[data-spec-value="${fieldType}"]`);
    const rowElement = specsContainer.querySelector(rowSelector);
    
    if (valueElement && rowElement) {
      if (newValue && 
          newValue !== 'undefined' && 
          newValue !== 'null' && 
          newValue !== '' && 
          newValue.trim() !== '') {
        valueElement.textContent = newValue;
        rowElement.style.display = 'block';
      } else {
        rowElement.style.display = 'none';
      }
    } else {
      console.log(`Could not find elements for ${fieldType}`);
      // Try to create the field if we have a value
      if (newValue && newValue !== 'undefined' && newValue !== 'null' && newValue !== '') {
        createSpecFieldIfNeeded(fieldType, newValue);
      }
    }
  }

  function hideSpecField(rowSelector) {
    const specsContainer = document.querySelector('[data-variant-specs]');
    const rowElement = specsContainer.querySelector(rowSelector);
    if (rowElement) {
      rowElement.style.display = 'none';
    }
  }

  function createSpecFieldIfNeeded(fieldType, value) {
    const specsContainer = document.querySelector('[data-variant-specs] .spacs_div');
    if (!specsContainer) return;

    // Check if this field already exists
    if (specsContainer.querySelector(`[data-spec-${fieldType}]`)) return;

    const fieldName = fieldType.toUpperCase();
    const listItem = document.createElement('li');
    listItem.className = 'soa specs_items';
    listItem.setAttribute(`data-spec-${fieldType}`, '');
    
    listItem.innerHTML = `
      <span class="sp_txt">${fieldName}</span>
      <span class="sp_value" data-spec-value="${fieldType}">${value}</span>
    `;
    
    specsContainer.appendChild(listItem);
    console.log(`Created ${fieldType} field with value:`, value);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSpecs);
  } else {
    initVariantSpecs();
  }

})();

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
